import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom'
import BottomNavigation from '@components/BottomNavigation'
import SdirLayout from '@components/Layout'
import Certificate from '@components/Certificate'
import Help from '@components/Help'
import QRCode from '@components/QRCode'
import Vessels from '@components/Vessels'
import Vessel from '@components/Vessel'
import './App.css'

const LegacyVesselCertificateRedirect = () => {
  const { certificateID } = useParams<{ certificateID?: string }>()
  const [searchParams] = useSearchParams()
  const queryID = searchParams.get('id') || searchParams.get('uuid')
  const legacyCertificateID = certificateID || queryID

  if (!legacyCertificateID) {
    return <Navigate to="/vessels" replace />
  }

  return <Navigate to={`/certificate?id=${encodeURIComponent(legacyCertificateID)}`} replace />
}

const AppRoutes = () => {
  const location = useLocation()
  const isScannerRoute = location.pathname === '/qrcode'

  return (
    <main id="app-main" className={`app__content${isScannerRoute ? ' app__content--scanner' : ''}`}>
      <div className="app__route-view" key={`${location.pathname}${location.search}`}>
        <Routes location={location}>
          <Route path="/vessels" element={<Vessels />} />
          <Route path="/vessels/vessel/:vesselID" element={<Vessel />} />
          <Route path="/vessels/vessel/:vesselID/:certificateID" element={<Certificate />} />
          <Route path="/qrcode" element={<QRCode />} />
          <Route path="/help" element={<Help />} />
          <Route path="/settings" element={<Navigate to="/help" replace />} />
          <Route path="/vessel" element={<LegacyVesselCertificateRedirect />} />
          <Route path="/vessel/:certificateID" element={<LegacyVesselCertificateRedirect />} />
          <Route path="/certificate" element={<Certificate />} />
          <Route path="/" element={<Navigate to="/vessels" replace />} />
          <Route path="*" element={<Navigate to="/vessels" replace />} />
        </Routes>
      </div>
    </main>
  )
}

const AppShell = () => {
  const location = useLocation()
  const isScannerRoute = location.pathname === '/qrcode'

  return (
    <div className={`app-shell${isScannerRoute ? ' app-shell--scanner' : ''}`}>
      {isScannerRoute ? (
        <>
          <div className="app app--scanner">
            <AppRoutes />
          </div>
          <BottomNavigation />
        </>
      ) : (
        <SdirLayout>
          <div className="app container">
            <AppRoutes />
          </div>
          <BottomNavigation />
        </SdirLayout>
      )}
    </div>
  )
}

const App = () => {
  return (
    <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <AppShell />
    </Router>
  )
}

export default App
